// extracted by mini-css-extract-plugin
export default {"innerWrapper":"LF-z","tooltipWrapper":"MF-z","icon":"NF-z","tooltip":"OF-z","content":"PF-z"};